var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ticket && _vm.schema
    ? _c(
        "v-form",
        { ref: "formTicket", attrs: { "lazy-validation": "" } },
        [
          _vm.isActionCreate
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          label: "Tipo de documento",
                          items: [
                            "DNI",
                            "Carnet de extranjería",
                            "RUC",
                            "Pasaporte",
                          ],
                        },
                        model: {
                          value: _vm.documentType,
                          callback: function ($$v) {
                            _vm.documentType = $$v
                          },
                          expression: "documentType",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        staticClass: "imput-icon",
                        attrs: {
                          label: "Número de documento",
                          "append-icon": "fa fa-search",
                          hint: "Presiona enter para autocompletar",
                          loading: _vm.loadingSearchContact,
                        },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.onSearchContact.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.documentNumber,
                          callback: function ($$v) {
                            _vm.documentNumber = $$v
                          },
                          expression: "documentNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("VFormBase", {
            attrs: {
              col: 12,
              value: _vm.ticket,
              schema: _vm.schema,
              row: { noGutters: false },
            },
          }),
          _vm._v(" "),
          _vm.isActionCreate && _vm.getActiveProducts
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "d-flex py-5", attrs: { cols: "12" } },
                    [
                      _c(
                        "p",
                        {
                          staticClass:
                            "font-weight-bold text-body my-auto w100",
                        },
                        [_vm._v("Productos relacionados")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-right" },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: { icon: "", small: "" },
                                              on: {
                                                click: _vm.onAddItemProduct,
                                              },
                                            },
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { small: "" } },
                                              [_vm._v(" fas fa-plus ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                467980271
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("span", [_vm._v("Agregar producto")]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("ItemsProducts", {
                        attrs: {
                          products: _vm.products,
                          discount: _vm.discount,
                          action: "create",
                        },
                        on: {
                          "update:products": function ($event) {
                            _vm.products = $event
                          },
                          "update:discount": function ($event) {
                            _vm.discount = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-row",
            [
              _vm.isActionCreate
                ? _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-alert",
                        { attrs: { dense: "", text: "", type: "info" } },
                        [
                          _vm._v(
                            "\n        Recuerda: Si creas una oportunidad con el "
                          ),
                          _c("strong", [_vm._v("número de documento")]),
                          _vm._v(
                            ", se creará un contacto o de\n        existir ya entre tus contactos se vinculará y quedará registrado en el historial de este contacto.\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.responseMessage
                ? _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-alert",
                        {
                          attrs: {
                            dense: "",
                            text: "",
                            type: _vm.responseType,
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.responseMessage) +
                              "\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            [
              _vm.action === "create"
                ? _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            loading: _vm.loading,
                            rounded: "",
                          },
                          on: { click: _vm.onCreate },
                        },
                        [_vm._v(" Guardar oportunidad ")]
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            rounded: "",
                            color: "primary",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.onUpdate },
                        },
                        [_vm._v(" Guardar ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", rounded: "" },
                          on: { click: _vm.cancelUpdate },
                        },
                        [_vm._v(" Cancelar ")]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }